"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPositionArray = exports.MobileLayoutTypeArray = exports.KeyValueLayoutType = exports.IconGridColumnsArray = void 0;
var IconGridColumnsArray = [2, 3, 4];
exports.IconGridColumnsArray = IconGridColumnsArray;
var KeyValueLayoutType;
exports.KeyValueLayoutType = KeyValueLayoutType;

(function (KeyValueLayoutType) {
  KeyValueLayoutType["grid"] = "grid";
  KeyValueLayoutType["scroll"] = "scroll";
  KeyValueLayoutType["stack"] = "stack";
  KeyValueLayoutType["carousel"] = "carousel";
})(KeyValueLayoutType || (exports.KeyValueLayoutType = KeyValueLayoutType = {}));

var MobileLayoutTypeArray = Object.values(KeyValueLayoutType);
exports.MobileLayoutTypeArray = MobileLayoutTypeArray;
var IconPositionArray = ['top', 'left'];
exports.IconPositionArray = IconPositionArray;